const BASE_API_PATH = process.env.VUE_APP_BASE_API_PATH || "";
const BASE_IOT_FLAG_API_PATH = process.env.VUE_APP_BASE_IOT_API_PATH || "";
export const API_PATH = `${BASE_API_PATH}/ruleTable/`;
export const IOT_API_PATH = `${BASE_IOT_FLAG_API_PATH}/ruleTable/`;
